// UI handoff only. No credentials, report payloads or model requests cross this bridge.
import { isDdirOrigin, isLocalPreviewOrigin } from './ddirOrigins.js';

export const ANDRE_BRIDGE_VERSION = 1;
const FIELDS = ['page', 'pageLabel', 'tab', 'tabLabel', 'driverId', 'driver', 'vehicle', 'dateFrom', 'dateTo', 'report'];

export function cleanAndreContext(value = {}) {
  const context = {};
  for (const key of FIELDS) {
    if (typeof value?.[key] === 'string' && value[key].trim()) context[key] = value[key].trim().slice(0, 160);
  }
  for (const key of ['dateFrom', 'dateTo']) {
    const date = context[key];
    if (date && (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(Date.parse(date)) || new Date(date).toISOString().slice(0, 10) !== date)) delete context[key];
  }
  return context;
}

export function allowedAndreHost(origin, ownOrigin, preview = false) {
  return isDdirOrigin(origin) || isLocalPreviewOrigin(origin, ownOrigin, preview);
}

export function acceptsAndreReady(event, parent, ownOrigin, preview = false) {
  return event.source === parent && allowedAndreHost(event.origin, ownOrigin, preview)
    && event.data?.type === 'ddir:andre:ready' && event.data.version === ANDRE_BRIDGE_VERSION;
}

export function acceptsAndreChild(event, frame, origin) {
  return Boolean(frame) && event.source === frame && event.origin === origin && event.data?.version === ANDRE_BRIDGE_VERSION
    && ['tacho:andre:hello', 'tacho:andre:context', 'tacho:andre:open'].includes(event.data.type);
}

export function andreContextLine(context = {}) {
  return [context.report || context.tabLabel || context.pageLabel || 'Tachograph', context.driver || context.vehicle || 'All drivers'].join(' · ');
}

export function andrePeriod(context = {}) {
  const format = date => new Date(`${date}T12:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  if (context.dateFrom && context.dateTo) return context.dateFrom === context.dateTo ? format(context.dateFrom) : `${format(context.dateFrom)} to ${format(context.dateTo)}`;
  if (context.dateFrom) return `From ${format(context.dateFrom)}`;
  if (context.dateTo) return `Up to ${format(context.dateTo)}`;
  return 'No period selected';
}
